export default "__VITE_ASSET__Dwi7jOZv__"